import React, { useCallback, useState } from "react"
import './print-upload-image-list.scss';

type ImageData = {
  src: string,
  name: string,
  size: number,
}

type ImageProps = ImageData;
const Image = (props: ImageProps) => {
  const {
    src,
    name,
  } = props;
  return (
    <div
      className="print_upload_image_list__image_box"
    >
      <img src={src} alt={name} />
    </div>
  )
}

type Props = {
  list: ImageData[],
}

export const PrintUploadImageList = (props: Props) => {
  const {
    list,
  } = props;
  const [selectData, setSelectData] = useState<ImageData | null>(null)
  const [tooltipStyle, setTooltipStyle] = useState<{ left?: string, top?: string, opacity: '0' | '1' }>({
    opacity: '0',
  });

  const viewSize = useCallback((size: number) => {
    if (size < 1024) {
        return `${size} B`;
    } else if (size < 1024 * 1024) {
        return `${(size / 1024).toFixed(2)} KB`;
    } else {
        return `${(size / (1024 * 1024)).toFixed(2)} MB`;
    }
  }, []);


  return (
    <>
      <div className="print_upload_image_list">
        {list.map((v, i) => (
          <div
            onMouseEnter={(e) => {
              setSelectData(v);
              setTooltipStyle({ left: `${e.pageX}px`, top: `${e.pageY}px`, opacity: '1' })
            }}
            onMouseMove={(e) => {
              setTooltipStyle({ left: `${e.pageX}px`, top: `${e.pageY}px`, opacity: '1' })
            }}
            onMouseLeave={(e) => {
              setTooltipStyle({ left: `${e.pageX}px`, top: `${e.pageY}px`, opacity: '0' })
            }}
          >
            <Image
              {...v}
              key={`print_img_${i}`}
            />
          </div>
        ))}
      </div>
      <div
        className="print_upload_image_list__tooltip"
        style={tooltipStyle}
      >
        <div>{selectData?.name ?? ''}</div>
        <div>{viewSize(selectData?.size ?? 0)}</div>
      </div>
    </>
  )
}